import React, { useRef, useState } from 'react'
import clsx from 'clsx'
import { useDrag, useDrop } from 'react-dnd'
import { makeStyles } from '@material-ui/core/styles'
import { CloseIcon, SquareCheckbox } from '~/legacy/components'

const useStyles = makeStyles(() => ({
  imageWrapper: {
    position: 'relative',
    marginTop: '24px',
    marginRight: '24px',
    '&:hover': {
      cursor: 'grab',
    },
  },
  image: {
    width: '150px',
    height: '150px',
    border: '1px solid #E0E0E0',
    borderRadius: '5px',
  },
  imageDragging: {
    opacity: 0.5,
  },
  imageDelete: {
    cursor: 'pointer',
    position: 'absolute',
    top: '4px',
    right: '4px',
    color: 'white',
    filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8))',
  },
  imageDeleteDragging: {
    display: 'none',
  },
  imageCheckbox: {
    position: 'absolute',
    top: '4px',
    left: '14px',
    color: 'white',
    filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8))',
  },
  deselectedImageCheckbox: {
    fill: 'white',
  },
}))

export const SelectableDraggableImage = ({
  children,
  index,
  moveImage,
  removeImage,
  imageKey,
  moveCrossCategory,
  isSelected,
  toggleSelection,
}) => {
  const classes = useStyles()
  const [mouseIsDown, setMouseIsDown] = useState(false)
  const ref = useRef(null)
  const [, drop] = useDrop({
    accept: 'image',
    collect: (monitor) => {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover: (item) => {
      if (!ref.current) {
        return
      }

      const dragIndex = item.index
      const hoverIndex = index
      const dragImageKey = item.imageKey
      const hoverImageKey = imageKey

      // If same category, allow reordering
      if (dragImageKey === hoverImageKey) {
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return
        }
        moveImage(dragIndex, hoverIndex, imageKey)
        item.index = hoverIndex
      }
      // If different category, provide visual feedback by temporarily moving
      else {
        // Temporarily move the image to show where it will be dropped
        moveCrossCategory(dragImageKey, hoverImageKey, item.index, hoverIndex)
        // Update the item's properties to reflect the new position
        item.index = hoverIndex
        item.imageKey = hoverImageKey
      }
    },
  })

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'image', index, imageKey },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: () => setMouseIsDown(false),
  })

  drag(drop(ref))

  return (
    <div className={classes.imageWrapper}>
      <div
        className={clsx(classes.image, isDragging && classes.imageDragging)}
        onMouseDown={() => setMouseIsDown(true)}
        onMouseUp={() => setMouseIsDown(false)}
        ref={ref}
      >
        {children}
      </div>
      {!mouseIsDown && (
        <>
          <SquareCheckbox
            className={classes.imageCheckbox}
            showHover={false}
            deSelectedCheckboxIconClasses={classes.deselectedImageCheckbox}
            checked={isSelected}
            onClick={toggleSelection}
          />
          <CloseIcon
            className={clsx(
              classes.imageDelete,
              isDragging && classes.imageDeleteDragging
            )}
            onClick={() => removeImage(index, imageKey)}
          />
        </>
      )}
    </div>
  )
}
